import { makeStyles } from '@material-ui/core';
import { isRtl, isMobile } from 'helpers/device_helper';
import { newShadows } from 'muiTheme/config/palette';

export const useKeepModalStyles = makeStyles((theme) => ({
    modal_container: {
        padding: '24px',
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
    },
    modal_button: {
        display: 'grid',
        gridTemplateColumns: `repeat(3, 1fr)`,
        width: '100%',
    },
    challengeKeeper: {
        color: '#ff9d48',
        fontWeight: 700,
    },
    title: { color: theme.palette.grayVariants[900] },
    subtitle: { color: theme.palette.grayVariants[700], marginTop: '4px' },
    first_subtitle: { color: theme.palette.grayVariants[600] },
    modal_content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        marginBottom: 8,
        textAlign: 'center',
    },
    closeIcon: {
        alignSelf: 'flex-start',
        justifySelf: 'flex-end',
        gridColumn: '3',
    },
    topIcon: {
        justifySelf: 'center',
        alignSelf: 'center',
        gridColumn: '2 / 3',
    },
    buttons: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    buttons_flex: {
        display: 'flex',
        flexDirection: 'row',
    },
    keepBtnModal: {
        height: 48,
        textWrap: 'nowrap',
        width: '100%',
    },
    closeBtnModal: {
        padding: '12px 16px',
        textWrap: 'nowrap',
        maxHeight: 48,
        width: '100%',
    },
    chip: {
        borderRadius: '8px',
        backgroundColor: theme.palette.grayVariants[200],
        padding: '4px 8px',
        alignSelf: 'center',
        marginTop: '4px',
        marginBottom: '8px',
    },
    typoChip: {
        color: theme.palette.grayVariants[600],
    },
    iconSize: {
        width: '58px',
        height: '54px',
    },
    modalContentTxtBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        marginBottom: 10,
        textAlign: 'center',
    },
    bannerContentTxtBlock: {
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: 12,
        // marginBottom: 10,
        textAlign: 'center',
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    marginBottomMobile: {
        marginBottom: 15,
    },
    marginBottomDefault: {
        marginBottom: 12,
    },
    marginBottomNone: {
        marginBottom: 0,
    },
}));

export const useWtBannerStyles = makeStyles((theme) => ({
    modal_container: {
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: newShadows.lg,
        border: `1px solid ${theme.palette.grayVariants[100]}`,
        borderRadius: '8px',
        width: '90%',

        ...isMobile({
            marginTop: '16px',
            border:
                theme.palette.type == 'dark'
                    ? `1px solid ${theme.palette.grayVariants[300]}`
                    : `1px solid ${theme.palette.grayVariants[100]}`,

            boxShadow: '0px 12px 16px -4px rgba(16, 24, 40, 0.08), 0px 4px 6px -2px rgba(16, 24, 40, 0.03)',
        }),
    },
    modal_button: {
        display: 'grid',
        gridTemplateColumns: `repeat(3, 1fr)`,
        width: '100%',
    },
    title: {
        color: theme.palette.grayVariants[900],
        textAlign: 'left',
        ...isRtl({
            textAlign: 'right',
        }),
    },
    subtitle: { color: theme.palette.grayVariants[700], marginTop: '4px' },
    first_subtitle: {
        color: theme.palette.grayVariants[600],
        textAlign: 'left',
        ...isRtl({
            textAlign: 'right',
        }),
    },
    modal_content: {
        display: 'flex',
        flexDirection: 'column',
        gap: 8,
        marginBottom: 8,
        textAlign: 'center',
    },
    closeIcon: {
        alignSelf: 'flex-start',
        justifySelf: 'flex-end',
        gridColumn: '3',
    },
    topIcon: {
        justifySelf: 'center',
        alignSelf: 'center',
        gridColumn: '2 / 3',
    },
    buttons: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
    },
    buttons_flex: {
        display: 'flex',
        flexDirection: 'row',
    },
    keepBtnModal: {
        height: 48,
        textWrap: 'nowrap',
        width: '100%',
    },
    closeBtnModal: {
        padding: '8px 16px',
        textWrap: 'nowrap',
        maxHeight: 40,
        width: '100%',
    },
    chip: {
        color: theme.palette.grayVariants[700],
    },
    typoChip: {
        color: theme.palette.grayVariants[600],
    },
    challengeKeeper: {
        color: '#ff9d48',
        fontWeight: 700,
    },
    iconSize: {
        width: '58px',
        height: '54px',
    },
    modalContentTxtBlock: {
        display: 'flex',
        flexDirection: 'column',
        gap: 5,
        marginBottom: 10,
        textAlign: 'center',
    },
    bannerContentTxtBlock: {
        display: 'flex',
        flexDirection: 'column-reverse',
        gap: 10,
        marginBottom: 10,
        textAlign: 'center',
    },
    modalContent: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        ...isMobile({
            // justifyContent: 'space-evenly',
        }),
    },
    marginBottomMobile: {
        marginBottom: 15,
    },
    marginBottomDefault: {
        marginBottom: 12,
    },
    marginBottomNone: {
        marginBottom: 0,
    },
}));
